import { render, staticRenderFns } from "./pickup.vue?vue&type=template&id=2d2c928d&"
import script from "./pickup.vue?vue&type=script&lang=js&"
export * from "./pickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports